module.exports = __webpack_public_path__ + "static/media/23a.ed58d6f8.jpg";